module.exports = __webpack_public_path__ + "h5/img/cs_17.6ca60980.jpeg";